import type { SanityPageBuilderFeaturesComparisonTableSection, SanityPageBuilderSection } from "@ouster/shared";
import { FeaturesComparisonTableBlockView, type FeaturesComparisonTableItemValue } from "~/features/blocks/inventory/features-comparison-table";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderFeaturesComparisonTableSection;
  };
};
export function SanityFeaturesComparisonTableSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const items = sectionContent.items?.map<FeaturesComparisonTableItemValue>(item => ({
    feature: item.feature,
    featuredIn: item.featuredIn?.join(",")
  })) ?? [];
  return <FeaturesComparisonTableBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} items={items} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}